export default {
  'user.login': 'Login',
  'user.signup': 'Signup',
  'user.profile': 'Profile',
  'user.reset_password': 'Reset Password',
  'user.user_management': 'User Management',
  'user.send_verification_sms': 'Send Verification SMS',
  'user.verification_check': 'Verification Check',
  'user.change_password': 'Change Password',
  'user.username_email': 'UserName / Email',
  'user.email': 'Email',
  'user.phone': 'Mobile Without Zero',
  'user.password': 'Password',
  'user.forgetpassword': 'Forgot your password',
  'user.loginwithgoogle': 'Login With Google',
  'user.createaccount': 'Create Account',
  'user.offerservices': 'We offer all travel services',
  'user.welcome': 'Welcome To Tripsi',
  'user.justwelcome': 'Login',
  'user.rememberme': 'Remember me',
  'user.donthaveaccount': 'Have not registered before?',
  'user.clickhere': 'Click here',
  'user.englishfirstname': 'First Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.agreemessage': ' I agree with',
  'user.rotapolicy': 'I agree the rules of Tripsi',
  'user.rotapolicy_tripord': 'I agree the rules of Tripord',
  'user.rotacopyright': 'Tripsi Copyright © 2018',
  'user.emptypass': 'Please enter old or new password',
  'user.oldpass': 'Old password is not match!',
  'user.employeeadd': 'Employee Added Successfully!',
  'user.changepass': 'Your password changed Successfully!',
  'user.tryagain': 'Please Try Again',
  'user.changepasssuccess': 'Your password has not been changed',
  'user.newpass': 'Please enter a new password',
  'user.loginerror': 'Username or password is incorrect',
  'user.userlock': 'Username is lock',
  'user.changepasserror': "New password and retype new password doesn't match",
  'user.tripsi': 'Tripsi',
  'user.tripord': 'Tripord',
  'user.userpoint': 'User Point',
  'user.duplicatedusername': 'Email is duplicated',
  'user.signuperror': 'Email must be unique',
  'user.avatar': 'Avatar',
  'user.forgetyour': 'Forget Your',

  'user.createyour': 'Create your',
  'user.account': 'account',
  'user.registerwith': 'Or register with',
  'user.acceptrules': 'Please accept the site rules',
  'user.fillallfield': 'please fill all fields',
  'user.favourites': 'Favourites',
  'user.nograde': 'No Grade',
  'user.phone': 'Phone Number',
  'user.has_account': 'I have Tripsi account',
  'user.has_account_tripord': 'I have Tripord account',
  'user.signup_free': 'Signup Free',
  'user.pass_recovery': 'Password recovery',
  'user.remember_password': 'Do you remember your password?',
  'authentication.slugone':
    'The most reliable supplier of tourism service in Iran',
  'user.otplogin': 'Sign in by sending a code via SMS',
  'user.otplogintitle': 'One-time password',
  'user.incorrectcode': 'The entered code is not correct',
  'user.untilresend': 'Until resend',
  'user.phoneoremail': 'Email Or Mobile',
  'user.loginwithusername': 'Login With Username',
  'user.sendcode': 'Send Code',
  'user.sendagain': 'Resend',
};
